var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("波次校验")]),
          _vm._v(" "),
          _vm.openWeight === _vm.OPEN_WEIGHT.OPEN
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "info" },
                  on: { click: _vm.connectDigitalScale }
                },
                [_vm._v("连接电子秤\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tally-header" }, [
        _c(
          "div",
          { staticClass: "input-desk-no" },
          [
            _c(
              "el-button",
              {
                staticClass: "c-background",
                staticStyle: { "background-color": "rgb(0, 140, 0)" },
                attrs: { disabled: _vm.$store.getters.tallyLock },
                on: {
                  click: function($event) {
                    return _vm.deskClick()
                  }
                }
              },
              [
                _c("span", { staticStyle: { color: "#fff" } }, [
                  _vm._v(" 工作台")
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.deskNo
          ? _c(
              "div",
              { staticClass: "desk-no" },
              [
                _c("el-button", { attrs: { type: "info" } }, [
                  _vm._v(_vm._s(_vm.deskNo))
                ])
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "fromWave",
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "输入波次号：" } },
                              [
                                _c("el-input", {
                                  ref: "inputRef",
                                  attrs: {
                                    placeholder: "波次号",
                                    disabled: _vm.waveNumInputDisabled
                                  },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.fetchWaveInfo.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.wave_picking_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wave_picking_no", $$v)
                                    },
                                    expression: "form.wave_picking_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.fetchWaveInfo }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  获取波次信息\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.waveInfo
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger", plain: "" },
                                        on: { click: _vm.handleExitCheck }
                                      },
                                      [_vm._v("退出校验")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger", plain: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.overCheck(1)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  完成校验\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-form-item", [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  _vm._s(_vm.waveInfo && _vm.waveInfo.prior_tip)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            !!_vm.userRemark
                              ? _c("el-form-item", [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        "仓库备注：" + _vm._s(_vm.userRemark)
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            [
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "fromDbid",
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "输入Dbid：" } },
                              [
                                _c("el-input", {
                                  ref: "inputRefDbid",
                                  attrs: { placeholder: "dbid=123456" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.validateWaveOrder.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.qrCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "qrCode", $$v)
                                    },
                                    expression: "form.qrCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    ref: "btnRefDbid",
                                    staticStyle: {
                                      "background-color": "#f56c6c",
                                      color: "#fff"
                                    },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.validateWaveOrder }
                                  },
                                  [_vm._v("校验")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "audio",
                      { attrs: { id: "audio_error", preload: "auto" } },
                      [
                        _c("source", {
                          attrs: {
                            src: require("../../assets/music/check_error.wav"),
                            type: "audio/wav"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "audio",
                      { attrs: { id: "audio_success", preload: "auto" } },
                      [
                        _c("source", {
                          attrs: {
                            src: require("../../assets/music/check_success.wav"),
                            type: "audio/wav"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _vm.waveInfo
              ? _c(
                  "div",
                  { staticClass: "data-list", attrs: { span: 24 } },
                  [
                    _vm._v("\n        数据列表："),
                    _c("el-button", [
                      _vm._v(" 总数：" + _vm._s(_vm.waveInfo.all_num) + " ")
                    ]),
                    _vm._v(" "),
                    _c("el-button", { attrs: { type: _vm.btnType } }, [
                      _vm._v(
                        "\n          已校验：" +
                          _vm._s(_vm.waveInfo.all_check_num) +
                          "\n        "
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-bottom": "0" } }, [
              _c(
                "div",
                { staticClass: "left-table-box" },
                [
                  _vm.waveInfo && _vm.waveInfo.goods.length > 0
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "goodsTable",
                          staticStyle: { "font-size": "18px !important" },
                          attrs: {
                            height: "450",
                            data: _vm.waveInfo.goods,
                            "tooltip-effect": "dark",
                            "cell-class-name": _vm.changeCellStyle
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "sku",
                              label: "SKU编号"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "校验数量" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.dbid_num) +
                                            "/" +
                                            _vm._s(
                                              scope.row.wave_picking_info_num
                                            )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1135633589
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "打标id" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleHiddenNumbers(
                                                scope.row.dbid_join
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._l(
                                            _vm.displayedNumbers(
                                              scope.row.dbid_join
                                            ),
                                            function(number, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.displayedNumbers(
                                                          scope.row.dbid_join
                                                        ).length > 1
                                                          ? number + ","
                                                          : number
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.shouldShowMoreNumbers(
                                            scope.row.dbid_join
                                          )
                                            ? _c("span", [_vm._v("...")])
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1791692122
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "co_val",
                              label: "颜色"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "si_val",
                              label: "尺码"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-table-box" },
                [
                  _vm.waveInfo && _vm.waveInfo.dbid_exception_list.length > 0
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "exceptionTable",
                          staticStyle: { "font-size": "18px !important" },
                          attrs: {
                            height: "450",
                            data: _vm.waveInfo.dbid_exception_list,
                            "tooltip-effect": "dark",
                            "cell-class-name": "_red-cell"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "serial_number",
                              label: "序号"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "dbid",
                              label: "打标id"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "goods_img",
                              label: "图片",
                              "show-overflow-tooltip": "",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "viewer",
                                              rawName: "v-viewer"
                                            }
                                          ],
                                          staticStyle: {
                                            width: "40px",
                                            height: "40px",
                                            overflow: "hidden",
                                            cursor: "pointer",
                                            margin: "auto"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%"
                                            },
                                            attrs: {
                                              src: scope.row.goods_img,
                                              alt: ""
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              412768096
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "co_val",
                              label: "颜色"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "exception_msg",
                              label: "异常原因"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          ref: "dialog",
          attrs: {
            visible: _vm.errorMsgDialogVisible,
            width: "30%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.errorMsgDialogVisible = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-size": "20px" } },
            [_vm._v("错误提示")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "text-align": "center",
                "font-size": "18px",
                color: "red"
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.errorMsg) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { id: "msg", type: "button" },
                  on: { click: _vm.closeMsgBox }
                },
                [_vm._v("\n        知道了\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "button" }, on: { click: _vm.exitCheck } },
                [_vm._v("退出校验")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { opacity: "1" } },
        [
          _vm.exPrint
            ? _c("lodop-print-for-check", {
                attrs: { type: _vm.type, "print-data": _vm.mdData },
                on: { PrintClose: _vm.PrintClose }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.overCheck_show, width: "30%", center: "" },
          on: {
            "update:visible": function($event) {
              _vm.overCheck_show = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-size": "20px" } },
            [_vm._v("完成校验提示")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "text-align": "center",
                "font-size": "18px",
                color: "red"
              }
            },
            [
              _vm._v(
                "\n      波次所需" +
                  _vm._s(_vm.diffStockOut_num.need) +
                  ", 已校验" +
                  _vm._s(_vm.diffStockOut_num.finish) +
                  "; 是否差异出库\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { id: "msg", type: "button" },
                  on: {
                    click: function($event) {
                      _vm.overCheck_show = false
                      _vm.$refs.inputRefDbid.$el.children[0].focus()
                    }
                  }
                },
                [_vm._v("继续校验")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.overCheck(0)
                    }
                  }
                },
                [_vm._v("完成出库")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.check_one_show,
            width: "30%",
            "close-on-click-modal": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.check_one_show = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-size": "16px" } },
            [_vm._v("波次所需商品为")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "text-align": "center",
                "font-size": "48px",
                color: "red"
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.check_one_num.all_num) + "件\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-size": "16px" } },
            [_vm._v("是否一键打包?")]
          ),
          _vm._v(" "),
          _c("el-input", {
            ref: "input_enter",
            nativeOn: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.checkOneOut.apply(null, arguments)
              }
            },
            model: {
              value: _vm.saoma_enter.str,
              callback: function($$v) {
                _vm.$set(_vm.saoma_enter, "str", $$v)
              },
              expression: "saoma_enter.str"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.check_one_show = false
                      _vm.$refs.inputRefDbid.$el.children[0].focus()
                    }
                  }
                },
                [_vm._v("继续校验")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "button" }, on: { click: _vm.checkOneOut } },
                [_vm._v("一键打包")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.check_one_valid_show,
            width: "30%",
            "close-on-click-modal": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.check_one_valid_show = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-size": "16px" } },
            [_vm._v("一键打包波次所需商品为")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "40px",
                "font-weight": "800",
                "justify-content": "center",
                display: "flex",
                margin: "auto"
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.valid_check_one_num,
                    expression: "valid_check_one_num"
                  }
                ],
                ref: "input_valid_check_one_num",
                staticStyle: {
                  width: "60px",
                  height: "52px",
                  "font-size": "30px",
                  padding: "0 5px",
                  "margin-right": "10px"
                },
                domProps: { value: _vm.valid_check_one_num },
                on: {
                  keydown: function($event) {
                    $event.stopPropagation()
                    return _vm.validCheckOneNum.apply(null, arguments)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.valid_check_one_num = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", [_vm._v("件")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "90%", padding: "20px" },
                  attrs: { type: "button" },
                  on: { click: _vm.closeValidCheckOneNum }
                },
                [_vm._v("扫码校验")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.check_shipping,
            width: "30%",
            "close-on-click-modal": false,
            "show-close": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.check_shipping = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-size": "16px" } },
            [_vm._v("\n      请输入前置打印的快递单号\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "justify-content": "center",
                display: "flex",
                margin: "auto"
              }
            },
            [
              _c("el-input", {
                ref: "check_shipping",
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.checkShipping.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.shipping_num,
                  callback: function($$v) {
                    _vm.shipping_num = $$v
                  },
                  expression: "shipping_num"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "90%", padding: "20px" },
                  attrs: { type: "button" },
                  on: { click: _vm.checkShipping }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.check_over_show,
            width: "30%",
            "close-on-click-modal": false,
            "show-close": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.check_over_show = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "font-size": "16px" } },
            [_vm._v("\n      " + _vm._s(_vm.check_over_msg) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", [
            _vm._v("计算（预估）重量：" + _vm._s(_vm.preWeight) + "g")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("称重重量：" + _vm._s(_vm.currentWeight * 1000) + "g")
          ]),
          _vm._v(" "),
          _c("el-input", {
            ref: "over_input_enter",
            nativeOn: {
              keyup: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.checkCompeleteClose.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar"
                    ])
                  ) {
                    return null
                  }
                  return _vm.checkCompeleteClose.apply(null, arguments)
                }
              ]
            },
            model: {
              value: _vm.saoma_enter.str,
              callback: function($$v) {
                _vm.$set(_vm.saoma_enter, "str", $$v)
              },
              expression: "saoma_enter.str"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          ref: "dialog",
          attrs: {
            visible: _vm.isShowExit,
            width: "30%",
            center: "",
            title: "退出校验"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowExit = $event
            }
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "text-align": "center", "font-size": "18px" } },
            [
              _vm._v(
                "\n      当前有已扫描校验商品，是否退出校验并生成异常数据\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "40px", width: "20%" },
                  on: {
                    click: function($event) {
                      _vm.isShowExit = false
                    }
                  }
                },
                [_vm._v("否")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { width: "20%" },
                  attrs: { type: "primary" },
                  on: { click: _vm.exitCheck }
                },
                [_vm._v("是")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowUserRemark,
            width: "30%",
            center: "",
            title: "用户长期备注"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowUserRemark = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "span",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onCloseUserRemark }
                        },
                        [
                          _vm._v(
                            "\n          关闭（" +
                              _vm._s(_vm.remarkSecond) +
                              "s）\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                "text-align": "center",
                "font-size": "18px",
                color: "red"
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.userRemark) + "\n    ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e554a98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e554a98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/Check1.vue
// module id = null
// module chunks = 